var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"Nav",class:_vm.className},_vm._l((_vm.navItems),function(item,index){return _c('div',{key:index,class:[
      _vm.activeItem === index ? 'Nav-Item Nav-Item--state_active' : 'Nav-Item'
    ],on:{"click":function($event){return _vm.onClick(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }